import Portfolio1 from "images/portfolio/portfolio1.jpg";
import Portfolio2 from "images/portfolio/portfolio2.jpg";
import Portfolio3 from "images/portfolio/portfolio3.jpg";
import Portfolio4 from "images/portfolio/portfolio4.jpg";
import mfzPortfolio from "images/portfolio/MFZ-portfolio.png";
import Client2 from "images/client2.jpeg";

export const PortfolioData = [
  {
    id: 1,
    postImageSrc:
      "https://images.unsplash.com/photo-1576678927484-cc907957088c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
    authorImageSrc: Client2,
    title: "GYM Member managment System",
    description:
      "I would say I liked working with Codistree, They was quick to understand the job at hand, and they quickly understood the existing codebase. If I ever need any more work in full stack web development, I would definitely work with them again",
    authorName: "Rahul Kumar",
    authorProfile: "Upwork Client",
    featured: true,

    projectImage: [
      {
        imageSrc:
          "https://images.unsplash.com/photo-1576678927484-cc907957088c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
      },
      {
        imageSrc: Portfolio1,
      },
      {
        imageSrc: Portfolio2,
      },
    ],
    subheading: "MFZ Gym.",
    heading: "GYM Member <span>managment System</span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 2,
    postImageSrc: Portfolio1,
    title: "Getting the most out of your vacation",
    authorName: "Aaron Patterson",
    projectImage: [
      {
        imageSrc: Portfolio1,
      },
      {
        imageSrc: Portfolio2,
      },
      {
        imageSrc:
          "https://images.unsplash.com/photo-1576678927484-cc907957088c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
      },
    ],
    subheading: "MFZ Gym.2",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 3,
    postImageSrc: Portfolio2,
    title: "Choosing the perfect Safaris in Africa",
    authorName: "Sam Phipphen",

    projectImage: [
      {
        imageSrc: Portfolio2,
      },
      {
        imageSrc: Portfolio3,
      },
      {
        imageSrc: Portfolio1,
      },
    ],
    subheading: "MFZ Gym.3",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 4,
    postImageSrc: Portfolio3,
    title: "Hiking during the monsoon in Asia",
    authorName: "Tony Hawk",

    projectImage: [
      {
        imageSrc: Portfolio3,
      },
      {
        imageSrc: Portfolio4,
      },
      {
        imageSrc: Portfolio2,
      },
    ],
    subheading: "MFZ Gym.4",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 5,
    postImageSrc: Portfolio4,
    title: "Must carry items while travelling to Thailand",
    authorName: "Himali Turn",

    projectImage: [
      {
        imageSrc: Portfolio4,
      },
      {
        imageSrc: mfzPortfolio,
      },
      {
        imageSrc: Portfolio1,
      },
    ],
    subheading: "MFZ Gym.5",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 6,
    postImageSrc: mfzPortfolio,
    title: "Must carry items while travelling to Thailand",
    authorName: "Himali Turn",

    projectImage: [
      {
        imageSrc: mfzPortfolio,
      },
      {
        imageSrc: Portfolio1,
      },
      {
        imageSrc: Portfolio2,
      },
    ],
    subheading: "MFZ Gym.6",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
  {
    id: 7,
    postImageSrc: Portfolio1,
    title: "Must carry items while travelling to Thailand",
    authorName: "Himali Turn",
    projectImage: [
      {
        imageSrc: Portfolio1,
      },
      {
        imageSrc: Portfolio4,
      },
      {
        imageSrc: Portfolio3,
      },
    ],
    subheading: "MFZ Gym.",
    heading: "GYM Member <span>managment System</<span>",
    description:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
  },
];
